import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';

export class CloudBaseLayer extends BaseProduct {
  public readonly id: ProductId = 'cloud_base';
  private lastModel: string = '';

  protected onActivate(): void {
    this.refresh();
  }

  protected onDeactivate(): void {
    this.layerManager.removeBufferedRasterLayer(this.id);
    this.layerManager.removeLayer(this.id);
    this.lastModel = '';
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(targetTimeMs?: number) {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const opacity = getLayerOpacity(this.id, 1.0);
    const current = targetTimeMs !== undefined ? targetTimeMs : state.currentTimeStep;
    if (!current) return;

    const rawModel = state.selectedModels[this.id];
    const model = (rawModel && rawModel !== 'blend') ? rawModel : 'nbm';

    if (this.lastModel && this.lastModel !== model) {
      this.layerManager.removeBufferedRasterLayer(this.id);
      this.layerManager.removeLayer(this.id);
    }
    this.lastModel = model;

    const ok = this.updateStandardInterpolatedRaster({
      layerId: this.id,
      product: this.id,
      model,
      targetTime: current,
      opacity,
      minzoom: 0,
      maxzoom: 6
    });
    if (!ok) {
      this.layerManager.removeBufferedRasterLayer(this.id);
      this.layerManager.removeLayer(this.id);
    }
  }
}

export default CloudBaseLayer;
